import { FC, useState } from "react";
import { LineStylePopup, ColorPickerPopup } from "shared/ui";
import type { DonchianChannelSettings, DCLineStyle } from "../../model";
import styles from "./ADXStylesTab.module.css";

type LineKey = "middle" | "top" | "bottom";
type PopupKey = LineKey | "background";

const LINES: { key: LineKey; label: string }[] = [
  { key: "middle", label: "middle" },
  { key: "top", label: "top" },
  { key: "bottom", label: "bottom" },
];

interface Props {
  settings: DonchianChannelSettings;
  onChange: (s: DonchianChannelSettings) => void;
}

export const DonchianChannelStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [openPopup, setOpenPopup] = useState<PopupKey | null>(null);

  const toggle = (key: PopupKey) =>
    setOpenPopup((prev) => (prev === key ? null : key));

  const updateLine = (key: LineKey, patch: Partial<DCLineStyle>) =>
    onChange({ ...settings, [key]: { ...settings[key], ...patch } });

  return (
    <div className={styles.tab}>
      {LINES.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <div className={styles.left}>
            <label className={styles.checkboxWrap}>
              <input
                type="checkbox"
                className={styles.checkboxInput}
                checked={settings[key].visible}
                onChange={(e) => updateLine(key, { visible: e.target.checked })}
              />
              <span className={styles.checkmark} />
            </label>
            <span className={styles.label}>{label}</span>
          </div>
          <div className={styles.btnWrap}>
            <button
              className={styles.colorBtn}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={() => toggle(key)}
            >
              <span className={styles.colorBtnSwatch} style={{ background: settings[key].color }} />
              <span className={styles.colorBtnWidth}>{settings[key].width}px</span>
            </button>
            {openPopup === key && (
              <LineStylePopup
                color={settings[key].color}
                width={settings[key].width}
                onColorChange={(c) => updateLine(key, { color: c })}
                onWidthChange={(w) => updateLine(key, { width: w })}
                onClose={() => setOpenPopup(null)}
              />
            )}
          </div>
        </div>
      ))}

      <div className={styles.row}>
        <div className={styles.left}>
          <label className={styles.checkboxWrap}>
            <input
              type="checkbox"
              className={styles.checkboxInput}
              checked={settings.background.visible}
              onChange={(e) =>
                onChange({ ...settings, background: { ...settings.background, visible: e.target.checked } })
              }
            />
            <span className={styles.checkmark} />
          </label>
          <span className={styles.label}>background</span>
        </div>
        <div className={styles.btnWrap}>
          <button
            className={styles.colorBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => toggle("background")}
          >
            <span className={styles.colorBtnSwatch} style={{ background: settings.background.color }} />
          </button>
          {openPopup === "background" && (
            <ColorPickerPopup
              color={settings.background.color}
              onChange={(c) => onChange({ ...settings, background: { ...settings.background, color: c } })}
              onClose={() => setOpenPopup(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
